import { useCurrentProject } from 'src/providers/current-project.provider'
import { ShowInDashboardFields } from './show-in-dashboard-fields.component'
import { useNodeRequestHumanReview } from './use-node-request-human-review.hook'

export function NodeDashboardSection() {
  const { humanReviewCheck, delayState, writeNodeValue, clearNodeValue, writeDelay } =
    useNodeRequestHumanReview()
  const { isAtLeastOneFeatureActivated } = useCurrentProject()

  if (!isAtLeastOneFeatureActivated(['dashboard', 'dashboard-v2'])) {
    return null
  }

  return (
    <div className="c-flex c-flex-col c-p-4">
      <ShowInDashboardFields
        isEnabled={!!humanReviewCheck}
        onEnabledChange={(isEnabled) => (isEnabled ? writeNodeValue() : clearNodeValue())}
        delay={delayState}
        onDelayChange={writeDelay}
      />
    </div>
  )
}
